const BaseModel = require('base/baseModel'),
    M = require('shared/messages/messages'),
    getPasswordPolicyErrorMessage = require('shared/helpers/getPasswordPolicyErrorMessage'),
    isValidUsaPhone = require('shared/helpers/validateUsaPhone'),
    isValidNonUsaPhone = require('shared/helpers/validateNonUsaPhone');

module.exports = BaseModel.extend({
    urlRoot: './api/requestAccess',
    validation: function () {
        let validation = {
            userName: [
                {
                    required: true,
                    msg: M.enterUsername()
                },
                {
                    maxLength: 50,
                    msg: M.lessThanNumberOfCharacters(['username', 50])
                }
            ],
            password: [
                {
                    required: true,
                    msg: M.enterPassword(),
                }
            ],
            passwordConfirmation: [
                {
                    required: true,
                    msg: M.enterPasswordConfirm()
                },
                {
                    equalTo: 'password',
                    msg: M.passwordConfirmationMismatch()
                }
            ],
            firstName: [
                {
                    required: true,
                    msg: M.firstNameEmpty()
                },
                {
                    maxLength: 100,
                    msg: M.lessThanNumberOfCharacters(['first-name', 100])
                }
            ],
            lastName: [
                {
                    required: true,
                    msg: M.lastNameEmpty()
                },
                {
                    maxLength: 100,
                    msg: M.lessThanNumberOfCharacters(['last-name', 100])
                }
            ],
            email: [
                {
                    pattern: 'email',
                    msg: M.enterValidEmail(),
                },
                {
                    required: true,
                    msg: M.enterValidEmail(),
                }
            ],
            cellCarrierId: function (value, attr, computedState) {
                if (computedState.cellNumber && !value) {
                    return M.cellCarrierMustBeSelectedIfCellNumberNotEmpty();
                }
            },
            cellNumber: function (value, attr, computedState) {
                if (value && !isValidUsaPhone(value)) {
                    return M.enterValidPhoneNumber();
                }
                if (computedState.cellCarrierId && !value) {
                    return M.cellNumberRequiredIfCellCarrierSelected();
                }
            }
        };
        if (this.passwordPolicy && this.passwordPolicy.get('clientRegex')) {
            validation.password.push({
                pattern: this.passwordPolicy.get('clientRegex'),
                msg: getPasswordPolicyErrorMessage(this.passwordPolicy)
            });
        }
        return validation;
    },
    initialize: function (options) {
        this.passwordPolicy = options.passwordPolicy;
        this._startDirtyTracking();
    }
});